module.exports = __webpack_public_path__ + "static/front-27529958e87eb8160bdc809efe38cba7.jpg";